import React, { useEffect, useState, useRef } from "react";
//i18n
import { withNamespaces } from "react-i18next";
import swal from "sweetalert2";
import {
  Row,
  Col,
  Card,
  CardBody,
  Container,
} from "reactstrap";

// Redux
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import "toastr/build/toastr.min.css";
//Import Breadcrumb
import Breadcrumbs from "../components/Common/Breadcrumb";
import "../../node_modules/react-bootstrap-table/dist/react-bootstrap-table-all.min.css";

import NotificationDashboard from "./Dashboard/NotificationDashboard";
// actions
import { changePassword } from "../store/actions";
import { postSubmitForm } from "../helpers/forms_helper";

const Notifications = (props) => {

  useEffect(() => {
    loadNotifications();
  }, []);
  const [notifications, setNotifications] = useState([]);
  const loadNotifications = async () => {
    let url = process.env.REACT_APP_BASEURL + "notifications/get_all";
    const response = await postSubmitForm(url, "");
    if (response && response.status === 1) {
      let notification_data = {
        unread_notifications: 0,
        notifications: response.data,
      };
      setNotifications(notification_data);
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs
            title={props.t("Notifications")}
            breadcrumbItem={props.t("All Notifications")}
          />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <NotificationDashboard
                    data={notifications}
                    setNotificationsRead={() => {}}
                    viewAll={false}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};
const mapStatetoProps = (state) => {
  const { error, message, message_type } = state.Login;
  return { error, message, message_type };
};
export default withRouter(
  connect(mapStatetoProps, {
    changePassword,
  })(withNamespaces()(Notifications))
);
